import React, { useState } from 'react';
import 'twin.macro';
import {
  Planner,
  PlannerCalendarPDFSettings,
} from '@teetsh/app/src/types/planner';
import { UserLocale } from '@teetsh/app/src/types/user';
import { useFormState } from 'react-final-form';
import { useParams } from 'react-router-dom';
import { useSendUpdateParamsToIframe } from '@teetsh/app/src/components/Iframe/useSendUpdateParamsToIframe';
import { IframePreviewPDF } from '@teetsh/app/src/components/Print/IframePreviewPDF';
import { buildPlannerCalendarPDFParams } from '@teetsh/app/src/containers/Planner/Main/Calendar/PreviewPDF/Sidebar/buildPlannerCalendarPDFParams';

interface Props {
  planner: Planner;
  date: Date;
  lng: UserLocale;
  selectedCategories: string[];
}

export function Body(props: Props) {
  const { planner, date, lng, selectedCategories } = props;
  const { values } = useFormState<PlannerCalendarPDFSettings>();

  const params = useParams<{
    schoolyearId: string;
    schoolId: string;
  }>();
  const schoolyearId = params.schoolyearId as string;
  const schoolId = params.schoolId as string;

  const url = new URL(
    `/print/annee-scolaire/${schoolyearId}/ecole/${schoolId}/planners/${planner.id}/calendar`,
    window.location.origin,
  );
  url.search = buildPlannerCalendarPDFParams({
    planner,
    lng,
    date,
    selectedCategories,
    settings: values,
  }).toString();

  const [urlAsString] = useState(url.toString());

  const { iframeRef } = useSendUpdateParamsToIframe({
    url,
    search: buildPlannerCalendarPDFParams({
      planner,
      lng,
      date,
      selectedCategories,
      settings: values,
    }),
  });

  return (
    <IframePreviewPDF
      landscape
      onePage
      iframeUrl={urlAsString}
      iframeRef={iframeRef}
    />
  );
}
